import { useDispatch, useSelector } from 'react-redux'
import { useEstimateOrder } from '@/apis/rest/generated/hooks'
import { ErrorResponseDto, EstimateOrderRequestDtoV1 } from '@/apis/rest/generated/types'
import { ErrorType } from '@/plugins/rest-api-v4'
import {
  doSetEstimateOrderRequestData,
  doSetEstimateOrderResponseData,
  doSetOrderPageCouponApplyMessage,
} from '@/stores/reduxData'
import { RootState } from '@/stores/store'

export const usePostEstimateOrder = () => {
  const dispatch = useDispatch()

  const estimatedOrderRequestSnapshot = useSelector(
    (rootState: RootState) => rootState.reduxDataReducers.estimatedOrderRequestSnapshot
  )

  const { mutateAsync } = useEstimateOrder({
    mutation: {
      onSuccess: (result) => {
        dispatch(doSetEstimateOrderResponseData(result))
      },
    },
  })

  const postEstimateOrder = async (data: EstimateOrderRequestDtoV1) => {
    if (!data.shippings.length) {
      return
    }

    try {
      const result = await mutateAsync({ data }, {})
      return result
    } catch (e) {
      // 상품 쿠폰 적용시 에러가 발생하면
      // 쿠폰 적용 toast 메시지를 초기화하고
      // 상품 쿠폰 정보가 없는 snapshot 으로 request 데이터를 복원한다.
      dispatch(doSetOrderPageCouponApplyMessage(''))
      if (estimatedOrderRequestSnapshot) {
        dispatch(doSetEstimateOrderRequestData(estimatedOrderRequestSnapshot))
      }
      return e as ErrorType<ErrorResponseDto>
    }
  }
  return { postEstimateOrder }
}
